/**
 * Vue Filter - Cornell Link
 */

/**
 * Return link to cornell website.
 *
 * @param {number} val Number value
 * @param {boolean} usePref Use prefix
 */


export default function statuteLink(title, sectionTitle) {
	// const sectionSplits = section?.match(/(\d+)([\w+]?)/)
	const section = sectionTitle.replace(/\([^)]*\)/g, "")
	// if (!sectionSplits) return `#`
	// let [full, number, hash] = sectionSplits
	// hash = hash ? hash.split(``).join(`_`) : hash

	return `https://uscode.house.gov/view.xhtml?req=granuleid:USC-prelim-title${title}-section${section}&num=0&edition=prelim`

	// return `https://www.law.cornell.edu/uscode/text/${title}/${full}#${hash}`
}
